import { InjectionToken } from '@angular/core';
import { GAConfig } from '../models/ga-config';

export const GA_CONFIG = new InjectionToken<GAConfig>('GA Config');
